"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  device: true,
  deviceMax: true,
  colors: true,
  styledTheme: true,
  ActionFlexContainer: true,
  Container: true,
  WizardContent: true,
  WizardFrame: true,
  StepperStyled: true,
  StepperBlock: true,
  TitleLine: true,
  getRequiredFields: true,
  isDisabled: true,
  determineVisibility: true,
  getValue: true,
  getExtraValues: true,
  reviewEditableFields: true,
  parseBools: true,
  checkCompanyHouseFn: true,
  mergeArraysInObject: true,
  ifBoolParse: true,
  formInputTypes: true,
  INPUT_TYPES: true,
  createForm: true,
  FormCompiler: true,
  VALIDATIONS: true,
  fieldIsEmpty: true,
  phoneIsNotValid: true,
  emailIsNotValid: true,
  multiEmailIsNotValid: true,
  emailIsNotEqual: true,
  dateIsInTheFuture: true,
  dateIsNotValid: true,
  creditCardIsValid: true,
  ibanIsValid: true,
  bicIsValid: true,
  sortCodeIsValid: true,
  listOptionsAreValid: true,
  checkInputProps: true,
  urlIsNotValid: true,
  getDMYhmDate: true,
  getUtcDate: true,
  getTableDate: true,
  transformDateToString: true,
  getTablePeriod: true,
  getTime: true,
  getFullTableDate: true,
  convertToLocaleDate: true,
  convertToLocaleDateddMMYY: true,
  convertToLocaleDateMMddYY: true,
  convertToLocaleDateYYYYMMDD: true,
  convertToLocaleDateddMMYYHH: true,
  convertToLocaleDateMMddYYHH: true,
  convertToLocaleDateDDMMYYHHmmss: true,
  getDMhmDate: true,
  capitalizeFirst: true,
  capitalizeWords: true,
  capitalize: true,
  validateEmail: true,
  validateRiskCountry: true,
  checkEmailExists: true,
  checkEmailExistsInStructure: true,
  randomId: true,
  isEmpty: true,
  isEmptyString: true,
  mergeDeep: true,
  isJSONString: true,
  quantityParser: true,
  getRandomArbitrary: true,
  getRandomInt: true,
  getBase64FileHeader: true,
  b64ToBlob: true,
  getFileExtensionFromB64: true,
  isNullOrUndefined: true,
  isObject: true,
  flattenObject: true,
  addIdentifierToArray: true,
  objectFiltering: true,
  debounce: true,
  hexToRgba: true,
  formatAmount: true,
  getISO2FromISO3CountryCode: true,
  parseData: true,
  parseDocumentProps: true,
  parseSettings: true,
  switchValueByType: true,
  titleCase: true,
  convertBlobToBase64: true,
  removeStringB64: true,
  CustomThemeProvider: true,
  selectStyles: true,
  FlexContainer: true,
  CardContainer: true,
  Flag: true,
  validateInput: true,
  FieldDescription: true,
  Errors: true,
  Button: true,
  Checkbox: true,
  PerfectCenter: true,
  HR: true,
  PureSpinner: true,
  PercentageLabel: true,
  ActionTitle: true,
  CardStrapLine: true,
  CardTitle: true,
  CardTitleSmall: true,
  ErrorParagraph: true,
  InfoText: true,
  PageTitle: true,
  Paragraph: true,
  Paragraph2: true,
  StrapLine: true,
  TitleH1: true,
  TitleH2: true,
  TitleH3: true,
  TitleH4: true,
  TitleH5: true,
  TitleH6: true,
  TitleOrangeBold: true,
  CheckInput: true,
  FormButton: true,
  NumberFormatInput: true,
  RadioInput: true,
  SelectInput: true,
  SliderInput: true,
  TextAreaInput: true,
  TextInput: true,
  DateSelector: true,
  CreditCard: true,
  RichTextInput: true,
  Iban: true,
  SortCode: true,
  Bic: true,
  Label: true,
  ColorPicker: true,
  useDebounce: true,
  useWindowSize: true,
  usePrevious: true
};
Object.defineProperty(exports, "ActionFlexContainer", {
  enumerable: true,
  get: function get() {
    return _styles2.ActionFlexContainer;
  }
});
Object.defineProperty(exports, "ActionTitle", {
  enumerable: true,
  get: function get() {
    return _ActionTitle.default;
  }
});
Object.defineProperty(exports, "Bic", {
  enumerable: true,
  get: function get() {
    return _Bic.default;
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button.default;
  }
});
Object.defineProperty(exports, "CardContainer", {
  enumerable: true,
  get: function get() {
    return _CardContainer.CardContainer;
  }
});
Object.defineProperty(exports, "CardStrapLine", {
  enumerable: true,
  get: function get() {
    return _CardStrapLine.default;
  }
});
Object.defineProperty(exports, "CardTitle", {
  enumerable: true,
  get: function get() {
    return _CardTitle.default;
  }
});
Object.defineProperty(exports, "CardTitleSmall", {
  enumerable: true,
  get: function get() {
    return _CardTitleSmall.default;
  }
});
Object.defineProperty(exports, "CheckInput", {
  enumerable: true,
  get: function get() {
    return _CheckInput.default;
  }
});
Object.defineProperty(exports, "Checkbox", {
  enumerable: true,
  get: function get() {
    return _Checkbox.Checkbox;
  }
});
Object.defineProperty(exports, "ColorPicker", {
  enumerable: true,
  get: function get() {
    return _ColorPicker.default;
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _styles2.Container;
  }
});
Object.defineProperty(exports, "CreditCard", {
  enumerable: true,
  get: function get() {
    return _CreditCard.default;
  }
});
Object.defineProperty(exports, "CustomThemeProvider", {
  enumerable: true,
  get: function get() {
    return _CustomThemeProvider.default;
  }
});
Object.defineProperty(exports, "DateSelector", {
  enumerable: true,
  get: function get() {
    return _DateSelector.default;
  }
});
Object.defineProperty(exports, "ErrorParagraph", {
  enumerable: true,
  get: function get() {
    return _ErrorParagraph.default;
  }
});
Object.defineProperty(exports, "Errors", {
  enumerable: true,
  get: function get() {
    return _Errors.default;
  }
});
Object.defineProperty(exports, "FieldDescription", {
  enumerable: true,
  get: function get() {
    return _FieldDescription.default;
  }
});
Object.defineProperty(exports, "Flag", {
  enumerable: true,
  get: function get() {
    return _Flag.Flag;
  }
});
Object.defineProperty(exports, "FlexContainer", {
  enumerable: true,
  get: function get() {
    return _FlexContainer.default;
  }
});
Object.defineProperty(exports, "FormButton", {
  enumerable: true,
  get: function get() {
    return _FormButton.default;
  }
});
Object.defineProperty(exports, "FormCompiler", {
  enumerable: true,
  get: function get() {
    return _FormCompiler.FormCompiler;
  }
});
Object.defineProperty(exports, "HR", {
  enumerable: true,
  get: function get() {
    return _HR.HR;
  }
});
Object.defineProperty(exports, "INPUT_TYPES", {
  enumerable: true,
  get: function get() {
    return _inputTypes.default;
  }
});
Object.defineProperty(exports, "Iban", {
  enumerable: true,
  get: function get() {
    return _Iban.default;
  }
});
Object.defineProperty(exports, "InfoText", {
  enumerable: true,
  get: function get() {
    return _InfoText.default;
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _Label.default;
  }
});
Object.defineProperty(exports, "NumberFormatInput", {
  enumerable: true,
  get: function get() {
    return _NumberFormatInput.default;
  }
});
Object.defineProperty(exports, "PageTitle", {
  enumerable: true,
  get: function get() {
    return _PageTitle.default;
  }
});
Object.defineProperty(exports, "Paragraph", {
  enumerable: true,
  get: function get() {
    return _Paragraph.default;
  }
});
Object.defineProperty(exports, "Paragraph2", {
  enumerable: true,
  get: function get() {
    return _Paragraph3.default;
  }
});
Object.defineProperty(exports, "PercentageLabel", {
  enumerable: true,
  get: function get() {
    return _labels.PercentageLabel;
  }
});
Object.defineProperty(exports, "PerfectCenter", {
  enumerable: true,
  get: function get() {
    return _PerfectCenter.PerfectCenter;
  }
});
Object.defineProperty(exports, "PureSpinner", {
  enumerable: true,
  get: function get() {
    return _PureSpinner.default;
  }
});
Object.defineProperty(exports, "RadioInput", {
  enumerable: true,
  get: function get() {
    return _RadioInput.default;
  }
});
Object.defineProperty(exports, "RichTextInput", {
  enumerable: true,
  get: function get() {
    return _RichTextInput.default;
  }
});
Object.defineProperty(exports, "SelectInput", {
  enumerable: true,
  get: function get() {
    return _SelectInput.default;
  }
});
Object.defineProperty(exports, "SliderInput", {
  enumerable: true,
  get: function get() {
    return _SliderInput.default;
  }
});
Object.defineProperty(exports, "SortCode", {
  enumerable: true,
  get: function get() {
    return _SortCode.default;
  }
});
Object.defineProperty(exports, "StepperBlock", {
  enumerable: true,
  get: function get() {
    return _styles2.StepperBlock;
  }
});
Object.defineProperty(exports, "StepperStyled", {
  enumerable: true,
  get: function get() {
    return _styles2.StepperStyled;
  }
});
Object.defineProperty(exports, "StrapLine", {
  enumerable: true,
  get: function get() {
    return _StrapLine.default;
  }
});
Object.defineProperty(exports, "TextAreaInput", {
  enumerable: true,
  get: function get() {
    return _TextAreaInput.default;
  }
});
Object.defineProperty(exports, "TextInput", {
  enumerable: true,
  get: function get() {
    return _TextInput.default;
  }
});
Object.defineProperty(exports, "TitleH1", {
  enumerable: true,
  get: function get() {
    return _TitleH.default;
  }
});
Object.defineProperty(exports, "TitleH2", {
  enumerable: true,
  get: function get() {
    return _TitleH3.default;
  }
});
Object.defineProperty(exports, "TitleH3", {
  enumerable: true,
  get: function get() {
    return _TitleH5.default;
  }
});
Object.defineProperty(exports, "TitleH4", {
  enumerable: true,
  get: function get() {
    return _TitleH7.default;
  }
});
Object.defineProperty(exports, "TitleH5", {
  enumerable: true,
  get: function get() {
    return _TitleH9.default;
  }
});
Object.defineProperty(exports, "TitleH6", {
  enumerable: true,
  get: function get() {
    return _TitleH11.default;
  }
});
Object.defineProperty(exports, "TitleLine", {
  enumerable: true,
  get: function get() {
    return _styles2.TitleLine;
  }
});
Object.defineProperty(exports, "TitleOrangeBold", {
  enumerable: true,
  get: function get() {
    return _TitleOrangeBold.default;
  }
});
Object.defineProperty(exports, "VALIDATIONS", {
  enumerable: true,
  get: function get() {
    return _validationsEnum.default;
  }
});
Object.defineProperty(exports, "WizardContent", {
  enumerable: true,
  get: function get() {
    return _styles2.WizardContent;
  }
});
Object.defineProperty(exports, "WizardFrame", {
  enumerable: true,
  get: function get() {
    return _styles2.WizardFrame;
  }
});
Object.defineProperty(exports, "addIdentifierToArray", {
  enumerable: true,
  get: function get() {
    return _helpers.addIdentifierToArray;
  }
});
Object.defineProperty(exports, "b64ToBlob", {
  enumerable: true,
  get: function get() {
    return _helpers.b64ToBlob;
  }
});
Object.defineProperty(exports, "bicIsValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.bicIsValid;
  }
});
Object.defineProperty(exports, "capitalize", {
  enumerable: true,
  get: function get() {
    return _helpers.capitalize;
  }
});
Object.defineProperty(exports, "capitalizeFirst", {
  enumerable: true,
  get: function get() {
    return _helpers.capitalizeFirst;
  }
});
Object.defineProperty(exports, "capitalizeWords", {
  enumerable: true,
  get: function get() {
    return _helpers.capitalizeWords;
  }
});
Object.defineProperty(exports, "checkCompanyHouseFn", {
  enumerable: true,
  get: function get() {
    return _Form.checkCompanyHouseFn;
  }
});
Object.defineProperty(exports, "checkEmailExists", {
  enumerable: true,
  get: function get() {
    return _helpers.checkEmailExists;
  }
});
Object.defineProperty(exports, "checkEmailExistsInStructure", {
  enumerable: true,
  get: function get() {
    return _helpers.checkEmailExistsInStructure;
  }
});
Object.defineProperty(exports, "checkInputProps", {
  enumerable: true,
  get: function get() {
    return _formValidations.checkInputProps;
  }
});
Object.defineProperty(exports, "colors", {
  enumerable: true,
  get: function get() {
    return _styles.colors;
  }
});
Object.defineProperty(exports, "convertBlobToBase64", {
  enumerable: true,
  get: function get() {
    return _helpers.convertBlobToBase64;
  }
});
Object.defineProperty(exports, "convertToLocaleDate", {
  enumerable: true,
  get: function get() {
    return _helpers.convertToLocaleDate;
  }
});
Object.defineProperty(exports, "convertToLocaleDateDDMMYYHHmmss", {
  enumerable: true,
  get: function get() {
    return _helpers.convertToLocaleDateDDMMYYHHmmss;
  }
});
Object.defineProperty(exports, "convertToLocaleDateMMddYY", {
  enumerable: true,
  get: function get() {
    return _helpers.convertToLocaleDateMMddYY;
  }
});
Object.defineProperty(exports, "convertToLocaleDateMMddYYHH", {
  enumerable: true,
  get: function get() {
    return _helpers.convertToLocaleDateMMddYYHH;
  }
});
Object.defineProperty(exports, "convertToLocaleDateYYYYMMDD", {
  enumerable: true,
  get: function get() {
    return _helpers.convertToLocaleDateYYYYMMDD;
  }
});
Object.defineProperty(exports, "convertToLocaleDateddMMYY", {
  enumerable: true,
  get: function get() {
    return _helpers.convertToLocaleDateddMMYY;
  }
});
Object.defineProperty(exports, "convertToLocaleDateddMMYYHH", {
  enumerable: true,
  get: function get() {
    return _helpers.convertToLocaleDateddMMYYHH;
  }
});
Object.defineProperty(exports, "createForm", {
  enumerable: true,
  get: function get() {
    return _FormCompiler.createForm;
  }
});
Object.defineProperty(exports, "creditCardIsValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.creditCardIsValid;
  }
});
Object.defineProperty(exports, "dateIsInTheFuture", {
  enumerable: true,
  get: function get() {
    return _formValidations.dateIsInTheFuture;
  }
});
Object.defineProperty(exports, "dateIsNotValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.dateIsNotValid;
  }
});
Object.defineProperty(exports, "debounce", {
  enumerable: true,
  get: function get() {
    return _helpers.debounce;
  }
});
Object.defineProperty(exports, "determineVisibility", {
  enumerable: true,
  get: function get() {
    return _Form.determineVisibility;
  }
});
Object.defineProperty(exports, "device", {
  enumerable: true,
  get: function get() {
    return _styles.device;
  }
});
Object.defineProperty(exports, "deviceMax", {
  enumerable: true,
  get: function get() {
    return _styles.deviceMax;
  }
});
Object.defineProperty(exports, "emailIsNotEqual", {
  enumerable: true,
  get: function get() {
    return _formValidations.emailIsNotEqual;
  }
});
Object.defineProperty(exports, "emailIsNotValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.emailIsNotValid;
  }
});
Object.defineProperty(exports, "fieldIsEmpty", {
  enumerable: true,
  get: function get() {
    return _formValidations.fieldIsEmpty;
  }
});
Object.defineProperty(exports, "flattenObject", {
  enumerable: true,
  get: function get() {
    return _helpers.flattenObject;
  }
});
Object.defineProperty(exports, "formInputTypes", {
  enumerable: true,
  get: function get() {
    return _inputTypes.default;
  }
});
Object.defineProperty(exports, "formatAmount", {
  enumerable: true,
  get: function get() {
    return _helpers.formatAmount;
  }
});
Object.defineProperty(exports, "getBase64FileHeader", {
  enumerable: true,
  get: function get() {
    return _helpers.getBase64FileHeader;
  }
});
Object.defineProperty(exports, "getDMYhmDate", {
  enumerable: true,
  get: function get() {
    return _helpers.getDMYhmDate;
  }
});
Object.defineProperty(exports, "getDMhmDate", {
  enumerable: true,
  get: function get() {
    return _helpers.getDMhmDate;
  }
});
Object.defineProperty(exports, "getExtraValues", {
  enumerable: true,
  get: function get() {
    return _Form.getExtraValues;
  }
});
Object.defineProperty(exports, "getFileExtensionFromB64", {
  enumerable: true,
  get: function get() {
    return _helpers.getFileExtensionFromB64;
  }
});
Object.defineProperty(exports, "getFullTableDate", {
  enumerable: true,
  get: function get() {
    return _helpers.getFullTableDate;
  }
});
Object.defineProperty(exports, "getISO2FromISO3CountryCode", {
  enumerable: true,
  get: function get() {
    return _helpers.getISO2FromISO3CountryCode;
  }
});
Object.defineProperty(exports, "getRandomArbitrary", {
  enumerable: true,
  get: function get() {
    return _helpers.getRandomArbitrary;
  }
});
Object.defineProperty(exports, "getRandomInt", {
  enumerable: true,
  get: function get() {
    return _helpers.getRandomInt;
  }
});
Object.defineProperty(exports, "getRequiredFields", {
  enumerable: true,
  get: function get() {
    return _Form.getRequiredFields;
  }
});
Object.defineProperty(exports, "getTableDate", {
  enumerable: true,
  get: function get() {
    return _helpers.getTableDate;
  }
});
Object.defineProperty(exports, "getTablePeriod", {
  enumerable: true,
  get: function get() {
    return _helpers.getTablePeriod;
  }
});
Object.defineProperty(exports, "getTime", {
  enumerable: true,
  get: function get() {
    return _helpers.getTime;
  }
});
Object.defineProperty(exports, "getUtcDate", {
  enumerable: true,
  get: function get() {
    return _helpers.getUtcDate;
  }
});
Object.defineProperty(exports, "getValue", {
  enumerable: true,
  get: function get() {
    return _Form.getValue;
  }
});
Object.defineProperty(exports, "hexToRgba", {
  enumerable: true,
  get: function get() {
    return _helpers.hexToRgba;
  }
});
Object.defineProperty(exports, "ibanIsValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.ibanIsValid;
  }
});
Object.defineProperty(exports, "ifBoolParse", {
  enumerable: true,
  get: function get() {
    return _Form.ifBoolParse;
  }
});
Object.defineProperty(exports, "isDisabled", {
  enumerable: true,
  get: function get() {
    return _Form.isDisabled;
  }
});
Object.defineProperty(exports, "isEmpty", {
  enumerable: true,
  get: function get() {
    return _helpers.isEmpty;
  }
});
Object.defineProperty(exports, "isEmptyString", {
  enumerable: true,
  get: function get() {
    return _helpers.isEmptyString;
  }
});
Object.defineProperty(exports, "isJSONString", {
  enumerable: true,
  get: function get() {
    return _helpers.isJSONString;
  }
});
Object.defineProperty(exports, "isNullOrUndefined", {
  enumerable: true,
  get: function get() {
    return _helpers.isNullOrUndefined;
  }
});
Object.defineProperty(exports, "isObject", {
  enumerable: true,
  get: function get() {
    return _helpers.isObject;
  }
});
Object.defineProperty(exports, "listOptionsAreValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.listOptionsAreValid;
  }
});
Object.defineProperty(exports, "mergeArraysInObject", {
  enumerable: true,
  get: function get() {
    return _Form.mergeArraysInObject;
  }
});
Object.defineProperty(exports, "mergeDeep", {
  enumerable: true,
  get: function get() {
    return _helpers.mergeDeep;
  }
});
Object.defineProperty(exports, "multiEmailIsNotValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.multiEmailIsNotValid;
  }
});
Object.defineProperty(exports, "objectFiltering", {
  enumerable: true,
  get: function get() {
    return _helpers.objectFiltering;
  }
});
Object.defineProperty(exports, "parseBools", {
  enumerable: true,
  get: function get() {
    return _Form.parseBools;
  }
});
Object.defineProperty(exports, "parseData", {
  enumerable: true,
  get: function get() {
    return _helpers.parseData;
  }
});
Object.defineProperty(exports, "parseDocumentProps", {
  enumerable: true,
  get: function get() {
    return _helpers.parseDocumentProps;
  }
});
Object.defineProperty(exports, "parseSettings", {
  enumerable: true,
  get: function get() {
    return _helpers.parseSettings;
  }
});
Object.defineProperty(exports, "phoneIsNotValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.phoneIsNotValid;
  }
});
Object.defineProperty(exports, "quantityParser", {
  enumerable: true,
  get: function get() {
    return _helpers.quantityParser;
  }
});
Object.defineProperty(exports, "randomId", {
  enumerable: true,
  get: function get() {
    return _helpers.randomId;
  }
});
Object.defineProperty(exports, "removeStringB64", {
  enumerable: true,
  get: function get() {
    return _helpers.removeStringB64;
  }
});
Object.defineProperty(exports, "reviewEditableFields", {
  enumerable: true,
  get: function get() {
    return _Form.reviewEditableFields;
  }
});
Object.defineProperty(exports, "selectStyles", {
  enumerable: true,
  get: function get() {
    return _selectStyles.default;
  }
});
Object.defineProperty(exports, "sortCodeIsValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.sortCodeIsValid;
  }
});
Object.defineProperty(exports, "styledTheme", {
  enumerable: true,
  get: function get() {
    return _styles.styledTheme;
  }
});
Object.defineProperty(exports, "switchValueByType", {
  enumerable: true,
  get: function get() {
    return _helpers.switchValueByType;
  }
});
Object.defineProperty(exports, "titleCase", {
  enumerable: true,
  get: function get() {
    return _helpers.titleCase;
  }
});
Object.defineProperty(exports, "transformDateToString", {
  enumerable: true,
  get: function get() {
    return _helpers.transformDateToString;
  }
});
Object.defineProperty(exports, "urlIsNotValid", {
  enumerable: true,
  get: function get() {
    return _formValidations.urlIsNotValid;
  }
});
Object.defineProperty(exports, "useDebounce", {
  enumerable: true,
  get: function get() {
    return _hooks.useDebounce;
  }
});
Object.defineProperty(exports, "usePrevious", {
  enumerable: true,
  get: function get() {
    return _hooks.usePrevious;
  }
});
Object.defineProperty(exports, "useWindowSize", {
  enumerable: true,
  get: function get() {
    return _hooks.useWindowSize;
  }
});
Object.defineProperty(exports, "validateEmail", {
  enumerable: true,
  get: function get() {
    return _helpers.validateEmail;
  }
});
Object.defineProperty(exports, "validateInput", {
  enumerable: true,
  get: function get() {
    return _validateInput.default;
  }
});
Object.defineProperty(exports, "validateRiskCountry", {
  enumerable: true,
  get: function get() {
    return _helpers.validateRiskCountry;
  }
});

var _styles = require("./styles");

Object.keys(_styles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _styles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _styles[key];
    }
  });
});

var _styles2 = require("./Wizard/styles");

var _Form = require("./CustomForm/Form.utils");

var _inputTypes = _interopRequireDefault(require("./CustomForm/constants/inputTypes"));

var _FormCompiler = require("./CustomForm/FormCompiler");

var _validationsEnum = _interopRequireDefault(require("./CustomForm/constants/validationsEnum"));

var _formValidations = require("./CustomForm/validations/formValidations");

var _helpers = require("./helpers");

var _CustomThemeProvider = _interopRequireWildcard(require("./CustomThemeProvider"));

Object.keys(_CustomThemeProvider).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CustomThemeProvider[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CustomThemeProvider[key];
    }
  });
});

var _dates = require("./dates");

Object.keys(_dates).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dates[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dates[key];
    }
  });
});

var _selectStyles = _interopRequireWildcard(require("./CustomForm/styles/selectStyles"));

Object.keys(_selectStyles).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _selectStyles[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _selectStyles[key];
    }
  });
});

var _FlexContainer = _interopRequireWildcard(require("./FlexContainer"));

Object.keys(_FlexContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _FlexContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _FlexContainer[key];
    }
  });
});

var _CardContainer = require("./CardContainer");

Object.keys(_CardContainer).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardContainer[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CardContainer[key];
    }
  });
});

var _Flag = require("./Flag/Flag");

var _validateInput = _interopRequireDefault(require("./CustomForm/validations/validateInput"));

var _FieldDescription = _interopRequireDefault(require("./FieldDescription"));

var _Errors = _interopRequireDefault(require("./CustomForm/fields/Errors"));

var _svg = require("./svg/");

Object.keys(_svg).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _svg[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _svg[key];
    }
  });
});

var _Button = _interopRequireDefault(require("./Button/"));

var _Button2 = require("./Button");

Object.keys(_Button2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Button2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Button2[key];
    }
  });
});

var _Checkbox = require("./Checkbox");

Object.keys(_Checkbox).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Checkbox[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Checkbox[key];
    }
  });
});

var _dates2 = require("./dates/");

Object.keys(_dates2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _dates2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _dates2[key];
    }
  });
});

var _PerfectCenter = require("./tools/PerfectCenter");

Object.keys(_PerfectCenter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PerfectCenter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PerfectCenter[key];
    }
  });
});

var _HR = require("./tools/HR");

Object.keys(_HR).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _HR[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _HR[key];
    }
  });
});

var _PureSpinner = _interopRequireDefault(require("./PureSpinner/"));

var _PureSpinner2 = require("./PureSpinner");

Object.keys(_PureSpinner2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PureSpinner2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PureSpinner2[key];
    }
  });
});

var _labels = require("./labels");

Object.keys(_labels).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _labels[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _labels[key];
    }
  });
});

var _ActionTitle = _interopRequireDefault(require("./Typography/ActionTitle/"));

var _ActionTitle2 = require("./Typography/ActionTitle");

Object.keys(_ActionTitle2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ActionTitle2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ActionTitle2[key];
    }
  });
});

var _CardStrapLine = _interopRequireDefault(require("./Typography/CardStrapLine/"));

var _CardStrapLine2 = require("./Typography/CardStrapLine");

Object.keys(_CardStrapLine2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardStrapLine2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CardStrapLine2[key];
    }
  });
});

var _CardTitle = _interopRequireDefault(require("./Typography/CardTitle/"));

var _CardTitle2 = require("./Typography/CardTitle");

Object.keys(_CardTitle2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardTitle2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CardTitle2[key];
    }
  });
});

var _CardTitleSmall = _interopRequireDefault(require("./Typography/CardTitleSmall/"));

var _CardTitleSmall2 = require("./Typography/CardTitleSmall");

Object.keys(_CardTitleSmall2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CardTitleSmall2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CardTitleSmall2[key];
    }
  });
});

var _ErrorParagraph = _interopRequireDefault(require("./Typography/ErrorParagraph/"));

var _ErrorParagraph2 = require("./Typography/ErrorParagraph");

Object.keys(_ErrorParagraph2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _ErrorParagraph2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ErrorParagraph2[key];
    }
  });
});

var _InfoText = _interopRequireDefault(require("./Typography/InfoText/"));

var _InfoText2 = require("./Typography/InfoText");

Object.keys(_InfoText2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _InfoText2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _InfoText2[key];
    }
  });
});

var _PageTitle = _interopRequireDefault(require("./Typography/PageTitle/"));

var _PageTitle2 = require("./Typography/PageTitle");

Object.keys(_PageTitle2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _PageTitle2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _PageTitle2[key];
    }
  });
});

var _Paragraph = _interopRequireDefault(require("./Typography/Paragraph/"));

var _Paragraph2 = require("./Typography/Paragraph");

Object.keys(_Paragraph2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Paragraph2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Paragraph2[key];
    }
  });
});

var _Paragraph3 = _interopRequireDefault(require("./Typography/Paragraph2/"));

var _Paragraph4 = require("./Typography/Paragraph2");

Object.keys(_Paragraph4).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Paragraph4[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Paragraph4[key];
    }
  });
});

var _StrapLine = _interopRequireDefault(require("./Typography/StrapLine/"));

var _StrapLine2 = require("./Typography/StrapLine");

Object.keys(_StrapLine2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _StrapLine2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _StrapLine2[key];
    }
  });
});

var _TitleH = _interopRequireDefault(require("./Typography/TitleH1/"));

var _TitleH2 = require("./Typography/TitleH1");

Object.keys(_TitleH2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TitleH2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TitleH2[key];
    }
  });
});

var _TitleH3 = _interopRequireDefault(require("./Typography/TitleH2/"));

var _TitleH4 = require("./Typography/TitleH2");

Object.keys(_TitleH4).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TitleH4[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TitleH4[key];
    }
  });
});

var _TitleH5 = _interopRequireDefault(require("./Typography/TitleH3/"));

var _TitleH6 = require("./Typography/TitleH3");

Object.keys(_TitleH6).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TitleH6[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TitleH6[key];
    }
  });
});

var _TitleH7 = _interopRequireDefault(require("./Typography/TitleH4/"));

var _TitleH8 = require("./Typography/TitleH4");

Object.keys(_TitleH8).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TitleH8[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TitleH8[key];
    }
  });
});

var _TitleH9 = _interopRequireDefault(require("./Typography/TitleH5/"));

var _TitleH10 = require("./Typography/TitleH5");

Object.keys(_TitleH10).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TitleH10[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TitleH10[key];
    }
  });
});

var _TitleH11 = _interopRequireDefault(require("./Typography/TitleH6/"));

var _TitleH12 = require("./Typography/TitleH6");

Object.keys(_TitleH12).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TitleH12[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TitleH12[key];
    }
  });
});

var _TitleOrangeBold = _interopRequireDefault(require("./Typography/TitleOrangeBold/"));

var _TitleOrangeBold2 = require("./Typography/TitleOrangeBold");

Object.keys(_TitleOrangeBold2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TitleOrangeBold2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TitleOrangeBold2[key];
    }
  });
});

var _CheckInput = _interopRequireWildcard(require("./CustomForm/fields/CheckInput"));

Object.keys(_CheckInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CheckInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CheckInput[key];
    }
  });
});

var _FormButton = _interopRequireDefault(require("./CustomForm/fields/FormButton"));

var _NumberFormatInput = _interopRequireWildcard(require("./CustomForm/fields/NumberFormatInput"));

Object.keys(_NumberFormatInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _NumberFormatInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _NumberFormatInput[key];
    }
  });
});

var _RadioInput = _interopRequireWildcard(require("./CustomForm/fields/RadioInput"));

Object.keys(_RadioInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _RadioInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RadioInput[key];
    }
  });
});

var _SelectInput = _interopRequireWildcard(require("./CustomForm/fields/SelectInput"));

Object.keys(_SelectInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SelectInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SelectInput[key];
    }
  });
});

var _SliderInput = _interopRequireDefault(require("./CustomForm/fields/SliderInput"));

var _TextAreaInput = _interopRequireWildcard(require("./CustomForm/fields/TextAreaInput"));

Object.keys(_TextAreaInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TextAreaInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TextAreaInput[key];
    }
  });
});

var _TextInput = _interopRequireWildcard(require("./CustomForm/fields/TextInput"));

Object.keys(_TextInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _TextInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _TextInput[key];
    }
  });
});

var _DateSelector = _interopRequireWildcard(require("./CustomForm/fields/DateSelector"));

Object.keys(_DateSelector).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _DateSelector[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _DateSelector[key];
    }
  });
});

var _CreditCard = _interopRequireWildcard(require("./CustomForm/fields/CreditCard"));

Object.keys(_CreditCard).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _CreditCard[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _CreditCard[key];
    }
  });
});

var _RichTextInput = _interopRequireWildcard(require("./CustomForm/fields/RichTextInput"));

Object.keys(_RichTextInput).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _RichTextInput[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RichTextInput[key];
    }
  });
});

var _RichTextInput2 = require("./CustomForm/fields/RichTextInput.config");

Object.keys(_RichTextInput2).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _RichTextInput2[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _RichTextInput2[key];
    }
  });
});

var _Iban = _interopRequireWildcard(require("./CustomForm/fields/Iban"));

Object.keys(_Iban).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Iban[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Iban[key];
    }
  });
});

var _SortCode = _interopRequireWildcard(require("./CustomForm/fields/SortCode"));

Object.keys(_SortCode).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _SortCode[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _SortCode[key];
    }
  });
});

var _Bic = _interopRequireWildcard(require("./CustomForm/fields/Bic"));

Object.keys(_Bic).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Bic[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Bic[key];
    }
  });
});

var _Label = _interopRequireWildcard(require("./CustomForm/fields/Label"));

Object.keys(_Label).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _Label[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _Label[key];
    }
  });
});

var _ColorPicker = _interopRequireDefault(require("./CustomForm/fields/ColorPicker"));

var _hooks = require("./hooks");

Object.keys(_hooks).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _hooks[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _hooks[key];
    }
  });
});

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }